import API from '../apiCreate'
import { getParams } from '../getParams'
import type {
  RequestCreateStatus,
  RequestUpdateItemsSorting,
  RequestUpdateStatuses,
  ResponseCheckIsUnused,
  ResponseStatuses,
} from '../types/crm/crm.types'
import type { EmptyResponse } from '../types/base.types'

/** Статусы лидов (настройки): `/v1/crm-lead-status/*`. */
export const crmStatusApi = {
  getAllStatuses: (params: { type: 'client' | 'lead' | 'all' }) =>
    API.get<ResponseStatuses>(
      `crm-lead-status/get-all-statuses/${getParams(params)}`,
    ),

  // обновление сущесвующих статусов
  updateStatus: (data: RequestUpdateStatuses) =>
    API.put<EmptyResponse>('crm/update-status', data),
  updateStatuses: (data: RequestUpdateStatuses) =>
    API.put<EmptyResponse>('crm-lead-status/update-statuses', data),

  insertStatus: (data: RequestCreateStatus) =>
    API.post<EmptyResponse>('crm-lead-status/insert-status', data),
  deleteStatus: (id: number) =>
    API.post<EmptyResponse>(`crm-lead-status/post-delete?id=${id}`),

  // проверка что статус не использовался и его можно изменить/удалить
  checkStatusIsUnused: (id: number) =>
    API.get<ResponseCheckIsUnused>(
      `crm-lead-status/check-status-is-unused?id=${id}`,
    ),
  updateStatusesSorting: (
    params: { funnel_id: number },
    data: RequestUpdateItemsSorting,
  ) =>
    API.put<EmptyResponse>('crm-lead-status/update-statuses-sorting', {
      funnel_id: params.funnel_id,
      ...data,
    }),
}
